import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import type { ProjectConfig } from '../types';

export interface ExportOptions {
  projectName: string;
  layers: [string, string, string, string];
  mockupHtml: string;
  variables: ProjectConfig;
}

function generateReadme(projectName: string): string {
  return `# ${projectName} — PromptForge 輸出

## 使用流程

1. 打開 Layer 1.md，將內容貼給 AI（Kimi / Claude / GPT）
2. 確認 AI 生成的代碼可編譯（pnpm install && pnpm build）
3. 打開 Layer 2.md，貼給 AI
4. 確認前台正常運作
5. 打開 Layer 3.md，貼給 AI
6. 確認後台可登入與儲存
7. 打開 Layer 4.md，貼給 AI
8. 執行部署

## 文件說明

- layer-1.md：骨架層（專案結構 + 型別 + API）
- layer-2.md：前台層（頁面 + 組件 + 業務邏輯）
- layer-3.md：後台層（Admin + 管理功能）
- layer-4.md：部署層（CI/CD + 腳本）
- mockup.html：視覺原型（可瀏覽器預覽）
- variables.json：項目配置（可導入 PromptForge 重新編輯）
- README.md：本文件

## 技術約束

- 套件管理器必須使用 pnpm
- 前端：React 18 + TypeScript + Vite + Tailwind CSS
- 後端：Cloudflare Worker + Hono
- 儲存：Cloudflare KV
`;
}

export async function exportProject(options: ExportOptions): Promise<void> {
  const zip = new JSZip();

  options.layers.forEach((layer, i) => {
    zip.file(`layer-${i + 1}.md`, layer);
  });

  zip.file('mockup.html', options.mockupHtml);
  zip.file('variables.json', JSON.stringify(options.variables, null, 2));
  zip.file('README.md', generateReadme(options.projectName));

  const blob = await zip.generateAsync({ type: 'blob' });
  saveAs(blob, `${options.projectName}-prompts.zip`);
}
